import { takeLatest, put } from 'redux-saga/effects';

import VideoMenuService from '../../../services/VideoMenuService';
import {
  getVideoMenuFail,
  getVideoMenuRequest,
  getVideoMenuSuccess,
  getVideoMenuListFail,
  getVideoMenuListRequest,
  getVideoMenuListSuccess,
  saveVideoMenuFail,
  saveVideoMenuRequest,
  saveVideoMenuSuccess,
  createVideoMenuRequest,
  createVideoMenuSuccess,
  createVideoMenuFail,
  deleteVideoMenuRequest,
  deleteVideoMenuSuccess,
  deleteVideoMenuFail,
  setVideoMenuListDirty,
  initVideoMenuRequest,
  initVideoMenuSuccess,
  initVideoMenuFail,
  duplicateVideoMenuRequest,
  duplicateVideoMenuSuccess,
  duplicateVideoMenuFail, clearVideoMenuList,
} from './actions';
import { logOut } from '../auth/actions';
import { apiCall } from '../../effects';
import { getErrorNotification } from '../../util';
import { notify } from '../notifications/actions';

function* getVideoMenuList({
  payload,
}: ReturnType<typeof getVideoMenuListRequest>) {
  try {
    const list = yield apiCall(VideoMenuService.list, payload);
    yield put(getVideoMenuListSuccess(list));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(getVideoMenuListFail());
  }
}

function* getVideoMenu({ payload }: ReturnType<typeof getVideoMenuRequest>) {
  try {
    const response = yield apiCall(VideoMenuService.get, payload);
    yield put(getVideoMenuSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(getVideoMenuFail());
  }
}

function* saveVideoMenu({ payload }: ReturnType<typeof saveVideoMenuRequest>) {
  try {
    const response = yield apiCall(VideoMenuService.save, payload.id, payload);
    yield put(saveVideoMenuSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(saveVideoMenuFail());
  }
}

function* createVideoMenu({
  payload,
}: ReturnType<typeof createVideoMenuRequest>) {
  try {
    const response = yield apiCall(VideoMenuService.create, payload);
    yield put(createVideoMenuSuccess(response));
  } catch (e) {
    yield put(initVideoMenuSuccess(payload));
    yield put(notify(getErrorNotification(e)));
    yield put(createVideoMenuFail());
  }
}

function* deleteVideoMenu({
  payload,
}: ReturnType<typeof deleteVideoMenuRequest>) {
  try {
    yield apiCall(VideoMenuService.delete, payload);
    yield put(deleteVideoMenuSuccess());
    yield put(setVideoMenuListDirty(true));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(deleteVideoMenuFail());
  }
}

function* getTemplateVideoMenu() {
  try {
    const response = yield apiCall(VideoMenuService.template);
    yield put(initVideoMenuSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(initVideoMenuFail());
  }
}

function* duplicateVideoMenu({ payload }: ReturnType<typeof duplicateVideoMenuRequest>) {
  try {
    const response = yield apiCall(VideoMenuService.duplicate, payload);
    yield put(duplicateVideoMenuSuccess(response));
    yield put(setVideoMenuListDirty(true));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(duplicateVideoMenuFail());
  }
}

function* clearList() {
  yield put(clearVideoMenuList());
}

export default [
  takeLatest(getVideoMenuListRequest.type, getVideoMenuList),
  takeLatest(getVideoMenuRequest.type, getVideoMenu),
  takeLatest(saveVideoMenuRequest.type, saveVideoMenu),
  takeLatest(createVideoMenuRequest.type, createVideoMenu),
  takeLatest(deleteVideoMenuRequest.type, deleteVideoMenu),
  takeLatest(initVideoMenuRequest.type, getTemplateVideoMenu),
  takeLatest(duplicateVideoMenuRequest.type, duplicateVideoMenu),
  takeLatest(logOut.type, clearList),
];
